/* hayakmodule */
define( '../src/hayak/sublayouts/m37-expander/m37-expander',[ 'jquery', 'lib/utils' ], function ( $, utils ) {

	'use strict';

	var Expander = function ( $component ) {

		this.$component = $component;

		return this;
	};

	Expander.prototype.init = function () {

		// set a unique id (safer than doing this inline)
		var uniqueID = utils.uniqueID(),
			triggerID = uniqueID + '_trigger',
			contentID = uniqueID + '_content';

		// cache dom els
		this.$trigger = this.$component.find( '[data-toggle]' ).eq( 0 );
		this.$content = this.$component.find( '[data-content]' ).eq( 0 );

		// add dynamic ids and props for aria tagging
		this.$trigger.attr( 'id', triggerID ).attr( 'aria-controls', contentID );
		this.$content.attr( 'id', contentID ).attr( 'aria-labelledby', triggerID );

		// classnames
		this.openTriggerClassname = 'm37-expander__trigger--open';
		this.openContentClassname = 'm37-expander__content--open';

		// toggle open if expanded
		if ( this.$content.attr( 'aria-expanded' ) === 'true' ) {
			this.toggle();
		}

		// bind events
		this.$trigger.on( 'click', $.proxy( this.toggle, this ) );
		
		var pagerUpdate = this.$component.find("[ data-pager-update ]");
		$(pagerUpdate).on('click', function () {
			debugger;
		});

	};

	Expander.prototype.toggle = function ( e ) {

		if ( e !== undefined ) {

			e.preventDefault();

		}

		var expanded = this.$content.attr( 'aria-expanded' ) === 'true',
				expanderForm = this.$content.find('[data-parsley-trigger]').eq(0).closest('form');

		this.$trigger.toggleClass( this.openTriggerClassname );
		this.$content.attr( 'aria-expanded', expanded = !expanded );
		this.$content.toggleClass( this.openContentClassname );

		// reinit parsley when form is expanded
		if (expanded && expanderForm.length) {
			expanderForm.parsley().destroy();
			window.setTimeout(function(){
				expanderForm.parsley();
			}, 10);
		}
	};

	return Expander;

} );

